module.exports = __webpack_public_path__ + "static/media/card-batch.29881ff7.png";